
interface SomeComponentProps {
  selectedFilter: string[];
  handleSubtractDataFunction: any
}

const icon = (
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.914062 7.75653H2.6772L7.30544 3.1283C7.42121 3.01253 7.51304 2.87509 7.57569 2.72383C7.63835 2.57257 7.6706 2.41045 7.6706 2.24673C7.6706 2.083 7.63835 1.92089 7.57569 1.76963C7.51304 1.61837 7.42121 1.48093 7.30544 1.36516C7.18967 1.24939 7.05223 1.15756 6.90097 1.0949C6.74971 1.03225 6.58759 1 6.42387 1C6.26015 1 6.09803 1.03225 5.94677 1.0949C5.79551 1.15756 5.65807 1.24939 5.5423 1.36516L0.914062 5.9934V7.75653Z"
      stroke="#EF5858"
      strokeWidth="0.881569"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.10156 1.80566L6.8647 3.5688"
      stroke="#EF5858"
      strokeWidth="0.881569"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CapsuleList: React.FC<SomeComponentProps> = ({ selectedFilter, handleSubtractDataFunction }) => {
  return (
    <div className="d-flex flex-wrap gap-2 align-items-center gap-2 mt-1">
      {selectedFilter?.map((capsule, index) => (
        <div
          key={index}
          className="capsule px-2 py-1 rounded-pill d-flex align-items-center bg-light text-main ff-semibold font-12 gap-2 bg-3 justify-content-between cursor-pointer"
          
          onClick={() => handleSubtractDataFunction(capsule)}
        >
          <div>{capsule}</div>
          <span className="bg-white rounded-circle d-flex align-items-center justify-content-center p-1 cursor-pointer">
            {/* {capsule.icon} */}
            {icon}
          </span>
        </div>
      ))}
    </div>
  );
}

export default CapsuleList;
